import PricingProviderType from '@/enums/valuation/PricingProviderType';
import WidgetInitialSettings from '../widget/WidgetInitialSettings';

export default class ValuationInitialSettings extends WidgetInitialSettings {
  public vehiclePricingProviderType: PricingProviderType = PricingProviderType.UkVehicleData;
}
